import { Routes, Route, Navigate } from 'react-router-dom'

// Public pages
import Login from '~pages/login'
import Logout from '~pages/logout'
import ForgotPassword from '~pages/forgot-password'
import PasswordReset from '~pages/password-reset'

// Protected app shell
import AppShell from './AppShell'

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/password-reset" element={<PasswordReset />} />

      {/* Protected routes - AppShell handles auth check and layout */}
      <Route path="/app/*" element={<AppShell />} />

      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}
